<template>
  <form class="ovg-form" @submit.prevent="onSubmit">
    <div class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-rut">RUT*</label>
        <input
          id="input-rut"
          v-model="rutFormatted"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.datosProvisorios.rut.$dirty &&
              ($v.datosProvisorios.rut.$invalid || !rutIsValid),
          }"
          placeholder="12345678-9"
          @input="$v.datosProvisorios.rut.$touch()"
        />
        <p
          v-if="
            $v.datosProvisorios.rut.$dirty &&
            ($v.datosProvisorios.rut.$invalid || !rutIsValid)
          "
          class="ovg-error"
        >
          Ingresa un RUT válido con puntos y guion.
        </p>
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-name">Nombre*</label>
        <input
          id="input-name"
          v-model="datosProvisorios.nombre"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.datosProvisorios.nombre.$dirty &&
              $v.datosProvisorios.nombre.$invalid,
          }"
          @blur="$v.datosProvisorios.nombre.$touch()"
        />
        <p
          v-if="
            $v.datosProvisorios.nombre.$dirty &&
            !$v.datosProvisorios.nombre.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
      <div class="ovg-field">
        <label class="ovg-label" for="input-apellido">Apellido*</label>
        <input
          id="input-apellido"
          v-model="datosProvisorios.apellido"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.datosProvisorios.apellido.$dirty &&
              $v.datosProvisorios.apellido.$invalid,
          }"
          @blur="$v.datosProvisorios.apellido.$touch()"
        />
        <p
          v-if="
            $v.datosProvisorios.apellido.$dirty &&
            !$v.datosProvisorios.apellido.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-email">Correo Electrónico*</label>
        <input
          id="input-email"
          v-model="datosProvisorios.email"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.datosProvisorios.email.$dirty &&
              $v.datosProvisorios.email.$invalid,
          }"
          placeholder="ej:correo@mail.cl"
          @blur="$v.datosProvisorios.email.$touch()"
        />
        <p
          v-if="
            $v.datosProvisorios.email.$dirty &&
            !$v.datosProvisorios.email.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
        <p
          v-else-if="
            $v.datosProvisorios.email.$dirty && !$v.datosProvisorios.email.email
          "
          class="ovg-error"
        >
          No es una direccion de correo valida
        </p>
      </div>
      <div class="ovg-field">
        <label class="ovg-label" for="input-telefono">Teléfono</label>
        <input
          id="input-telefono"
          v-model="datosProvisorios.telefono"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.datosProvisorios.telefono.$dirty &&
              $v.datosProvisorios.telefono.$invalid,
          }"
          maxlength="9"
          @blur="$v.datosProvisorios.telefono.$touch()"
        />
        <p
          v-if="
            $v.datosProvisorios.telefono.$dirty &&
            !$v.datosProvisorios.telefono.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
        <p
          v-else-if="
            $v.datosProvisorios.telefono.$dirty &&
            !$v.datosProvisorios.telefono.numeric
          "
          class="ovg-error"
        >
          Solo puedes ingresar numeros
        </p>
        <p
          v-else-if="
            $v.datosProvisorios.telefono.$dirty &&
            !$v.datosProvisorios.telefono.minLength
          "
          class="ovg-error"
        >
          Tienes que ingresar 8 digitos
        </p>
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-region">Región</label>
        <select
          id="input-region"
          v-model="datosProvisorios.region"
          class="ovg-select"
          :class="{
            'ovg-select--error':
              $v.datosProvisorios.region.$dirty &&
              $v.datosProvisorios.region.$invalid,
          }"
          @change="onRegionChange"
        >
          <option :value="null">Selecciona</option>
          <option
            v-for="opt in regionOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
        <p
          v-if="
            $v.datosProvisorios.region.$dirty &&
            !$v.datosProvisorios.region.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
      <div class="ovg-field">
        <label class="ovg-label" for="input-comuna">Comuna</label>
        <select
          id="input-comuna"
          v-model="datosProvisorios.comuna"
          class="ovg-select"
          :class="{
            'ovg-select--error':
              $v.datosProvisorios.comuna.$dirty &&
              $v.datosProvisorios.comuna.$invalid,
          }"
        >
          <option :value="null">Selecciona</option>
          <option
            v-for="opt in comunaOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
        <p
          v-if="
            $v.datosProvisorios.comuna.$dirty &&
            !$v.datosProvisorios.comuna.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-address"
          >Dirección de la Calle</label
        >
        <input
          id="input-address"
          v-model="datosProvisorios.direccion"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.datosProvisorios.direccion.$dirty &&
              $v.datosProvisorios.direccion.$invalid,
          }"
          placeholder="Nombre de la Calle y número de la casa, departamento, oficina, etc,"
          @blur="$v.datosProvisorios.direccion.$touch()"
        />
        <p
          v-if="
            $v.datosProvisorios.direccion.$dirty &&
            !$v.datosProvisorios.direccion.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div class="ovg-card__footer">
      <button type="submit" class="ovg-btn ovg-btn--primary">
        Siguiente Paso
      </button>
    </div>
  </form>
</template>

<script>
import { required, email, numeric, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import validateRut from '../../../../utils/validateRut'
import validateEmail from '../../../../utils/validateEmail'

export default {
  props: ['setDatosProvisorios', 'datosReturn'],
  data() {
    return {
      emailInvalid: true,
      datosProvisorios: {
        nombre: this.datosReturn.nombre ? this.datosReturn.nombre : null,
        apellido: this.datosReturn.apellido ? this.datosReturn.apellido : null,
        rut: this.datosReturn.rut ? this.datosReturn.rut : null,
        email: this.datosReturn.email ? this.datosReturn.email : null,
        comuna: this.datosReturn.comuna ? this.datosReturn.comuna : null,
        telefono: this.datosReturn.telefono ? this.datosReturn.telefono : null,
        direccion: this.datosReturn.direccion
          ? this.datosReturn.direccion
          : null,
        region: this.datosReturn.region ? this.datosReturn.region : null,
      },
    }
  },
  validations: {
    datosProvisorios: {
      rut: { required },
      nombre: { required },
      apellido: { required },
      email: { required, email },
      telefono: {
        required,
        numeric,
        minLength: minLength(8),
      },
      direccion: { required },
      comuna: { required },
      region: { required },
    },
  },
  computed: {
    rutIsValid() {
      return validateRut(this.datosProvisorios.rut || '')
    },
    rutFormatted: {
      get() {
        return this.datosProvisorios.rut
          ? this.datosProvisorios.rut.replace(/\./g, '')
          : ''
      },
      set(v) {
        const rutLimpio = v.replace(/[^0-9kK]/g, '')
        const cuerpo = rutLimpio.slice(0, -1)
        const dv = rutLimpio.slice(-1).toUpperCase()

        if (rutLimpio.length < 2) {
          this.datosProvisorios.rut = rutLimpio
          return
        }

        let cuerpoFormatoMiles = cuerpo
          .toString()
          .split('')
          .reverse()
          .join('')
          .replace(/(?=\d*\.?)(\d{3})/g, '$1.')

        cuerpoFormatoMiles = cuerpoFormatoMiles
          .split('')
          .reverse()
          .join('')
          .replace(/^[\.]/, '') // eslint-disable-line

        this.datosProvisorios.rut = `${cuerpoFormatoMiles.replace(
          /[^0-9kK]/g,
          ''
        )}-${dv}`
      },
    },
    regionOptions() {
      return this.regiones.map((region) => ({
        value: region.region,
        text: region.region,
      }))
    },
    comunaOptions() {
      if (this.datosProvisorios.region) {
        const region = this.regiones.find(
          (c) => c.region === this.datosProvisorios.region
        )
        if (region && region.comunas) {
          return region.comunas.map((c) => ({
            value: c,
            text: c,
          }))
        }
      }
      return []
    },
    ...mapGetters('ClientStore', ['regiones']),
  },
  watch: {
    datosReturn: {
      handler() {
        this.datosProvisorios = {
          nombre: this.datosReturn.nombre ? this.datosReturn.nombre : null,
          apellido: this.datosReturn.apellido
            ? this.datosReturn.apellido
            : null,
          rut: this.datosReturn.rut ? this.datosReturn.rut : null,
          email: this.datosReturn.email ? this.datosReturn.email : null,
          comuna: this.datosReturn.comuna ? this.datosReturn.comuna : null,
          telefono: this.datosReturn.telefono
            ? this.datosReturn.telefono
            : null,
          direccion: this.datosReturn.direccion
            ? this.datosReturn.direccion
            : null,
          region: this.datosReturn.region ? this.datosReturn.region : null,
        }
      },
      deep: true,
    },
  },
  methods: {
    onRegionChange() {
      this.datosProvisorios.comuna = null
      this.$v.datosProvisorios.region.$touch()
    },
    async onSubmit() {
      if (
        this.$v.datosProvisorios.nombre.$invalid ||
        this.$v.datosProvisorios.apellido.$invalid ||
        this.$v.datosProvisorios.region.$invalid ||
        this.$v.datosProvisorios.comuna.$invalid ||
        this.$v.datosProvisorios.direccion.$invalid ||
        this.$v.datosProvisorios.telefono.$invalid ||
        this.$v.datosProvisorios.email.$invalid ||
        this.$v.datosProvisorios.rut.$invalid
      ) {
        this.$bvToast.toast('Rellene todos los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else if (!this.rutIsValid) {
        this.$bvToast.toast('RUT inválido. Verifique el dígito verificador.', {
          variant: 'danger',
        })
      } else {
        this.setDatosProvisorios(this.datosProvisorios)
      }
    },
    tagValidator(tag) {
      const validate = validateEmail(tag)
      if (validate) {
        this.emailInvalid = true
        return validate
      }
      this.emailInvalid = false
      return validate
    },
  },
}
</script>
